import Vue from 'vue'
import VueCarousel from '@chenfengyuan/vue-carousel'

Vue.component(VueCarousel.name, VueCarousel)
Vue.component('vcarousel', VueCarousel)



// WEBPACK FOOTER //
// ./src/front/init/components/carousel2.js